import { gkApi } from './index';

const LIST_PARAMS = { limit: 500 };

const locationApi = gkApi.injectEndpoints({
  endpoints: (builder) => ({
    listCrewLocations: builder.query({
      query: (eventId) => ({
        url: '/crew-location/',
        method: 'get',
        params: { ...LIST_PARAMS, event: eventId },
      }),
      providesTags: ['LOCATION_LIST'],
    }),
    getCrewLocationDetails: builder.query({
      query: (locationId) => ({
        url: `/crew-location/${locationId}/`,
        method: 'get',
      }),
    }),
    getCrewLocationReport: builder.query({
      query: (locationId) => ({
        url: `/crew-location/report/${locationId}/`,
        method: 'get',
      }),
    }),
    listBackstageLocations: builder.query({
      query: (eventId) => ({
        url: '/backstage-location/',
        method: 'get',
        params: { ...LIST_PARAMS, event: eventId },
      }),
      providesTags: ['LOCATION_LIST'],
    }),
    getBackstageLocationDetails: builder.query({
      query: (locationId) => ({
        url: `/backstage-location/${locationId}/`,
        method: 'get',
      }),
    }),
    getBackstageLocationReport: builder.query({
      query: (locationId) => ({
        url: `/backstage-location/report/${locationId}/`,
        method: 'get',
      }),
    }),
    listBarLocations: builder.query({
      query: (eventId) => ({
        url: `/bar-location/`,
        method: 'get',
        params: { ...LIST_PARAMS, event: eventId },
      }),
      providesTags: ['LOCATION_LIST'],
    }),
    listStorageLocations: builder.query({
      query: (eventId) => ({
        url: `/storage-location/`,
        method: 'get',
        params: { ...LIST_PARAMS, event: eventId },
      }),
    }),
    getDeliveriesReport: builder.query({
      query: (eventId) => ({
        url: `/event/${eventId}/report/deliveries/`,
        method: 'get',
      }),
    }),
    // Pivoted twin of the Excel export: locations as rows, articles as columns.
    getDeliveriesMatrix: builder.query({
      query: (eventId) => ({
        url: `/event/${eventId}/report/deliveries/matrix/`,
        method: 'get',
      }),
    }),
    // --- Lieferziel-Import (Admin) -----------------------------------------
    // One backend endpoint serves both phases: `commit: false` parses and
    // validates only, `commit: true` writes. The file is uploaded again on
    // confirm and matched against the digest the preview returned, so nothing
    // is held server-side between the two calls.
    importLocations: builder.mutation({
      query: ({ eventId, file, locationType, commit = false, fileDigest }) => {
        const form = new FormData();
        form.append('file', file);
        form.append('location_type', locationType);
        form.append('commit', commit ? 'true' : 'false');
        if (fileDigest) form.append('file_digest', fileDigest);
        return {
          url: `/event/${eventId}/location-import/`,
          method: 'POST',
          body: form,
        };
      },
      // Only a commit changes anything; a preview must not blow the cache away.
      invalidatesTags: (result, error, { commit }) =>
        commit ? ['LOCATION_LIST'] : [],
    }),
    getLocationImportTemplate: builder.query({
      query: (locationType) => ({
        url: '/location-import/template/',
        method: 'GET',
        params: { location_type: locationType },
        responseHandler: (response) => response.blob(),
      }),
    }),
    // Event-scoped Excel export of delivered qty per location x article.
    // Lazy + blob responseHandler so it fires on click and returns a Blob
    // (see getCashRegisterReportPdf in marktApi.js for the same pattern).
    getDeliveryReportExcel: builder.query({
      query: (eventId) => ({
        url: `/event/${eventId}/report/deliveries/excel/`,
        method: 'get',
        responseHandler: (response) => response.blob(),
      }),
    }),
  }),
});

export const {
  useListCrewLocationsQuery,
  useGetCrewLocationDetailsQuery,
  useGetCrewLocationReportQuery,
  useListBackstageLocationsQuery,
  useGetBackstageLocationDetailsQuery,
  useGetBackstageLocationReportQuery,
  useListBarLocationsQuery,
  useListStorageLocationsQuery,
  useGetDeliveriesReportQuery,
  useGetDeliveriesMatrixQuery,
  useLazyGetDeliveryReportExcelQuery,
  useImportLocationsMutation,
  useLazyGetLocationImportTemplateQuery,
} = locationApi;
